import { Tab, TabsNavigation } from "pepsico-ds";

import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FeatureToggle, useFeatureToggle } from "../../../utils/featureToggle";

const HistoryLogsListPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const showConfigurationTab = useFeatureToggle(
    FeatureToggle.showConfigurationHistoryLogs
  );

  useEffect(() => {
    if (
      showConfigurationTab &&
      location.pathname.includes("/history-logs-configuration")
    ) {
      setSelectedTab(2);
    } else if (location.pathname.includes("/history-logs-content")) {
      setSelectedTab(1);
    } else {
      setSelectedTab(0);
    }
  }, [location.pathname, showConfigurationTab]);

  const handleTabChange = (index) => {
    setSelectedTab(index);
    if (index === 0) {
      navigate("/system-setting/history-logs");
    } else if (index === 1) {
      navigate("/system-setting/history-logs-content");
    } else if (showConfigurationTab && index === 2) {
      navigate("/system-setting/history-logs-configuration");
    }
  };

  return (
    <div className="px-3">
      <div className="container-card">
        <div className="page-header">
          <h6 className="font-bold font-lg">History Logs</h6>
        </div>
        <TabsNavigation
          className="tabs-wrap"
          style={{ borderBottom: "2px solid #D7E5F8" }}
          onUpdate={handleTabChange}
          selectedIndex={selectedTab}
        >
          <Tab label="Campaigns" />
          <Tab label="Content Studio" />
          {showConfigurationTab && <Tab label="Configuration" />}
        </TabsNavigation>
        <Outlet />
      </div>
    </div>
  );
};

export default HistoryLogsListPage;
